export enum TipoRegistroFeedback {
  RegistroOperacional = 1,
  RegistroExecutivo = 2,
  HistoricoFeedbackExecutivo = 3
}
